import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { PubComponent } from '../../pub-component';
import { LionEngine } from '../../../engine/io-engine';
import { PubComponentListener } from '../../pub-component-listener';
import { IoniScriptManager } from 'src/app/engine/io-manager';
import { MatSelectionListChange } from '@angular/material/list';

@Component({
  selector: 'selection-list',
  templateUrl: './selection-list.component.html',
  styleUrls: ['./selection-list.component.scss']
})
export class SelectionListComponent implements OnInit, AfterViewInit, PubComponent {

  @ViewChildren('listItem') listItemElements!: QueryList<ElementRef>;

  listener: PubComponentListener;
  data: any;
  resolveFunction: any;
  title: string = '';

  listItems: any[];
  contentItems: {} = {};
  selectedItems: any[] = [];

  submitIonFunction: any;
  submitButtonLabel = 'Save';
  actionIonFunction = null;
  showButton = false;
  displayButton = true;
  singleSelect = true;
  padding_top = '0px';
  color_set = {};
  itemHeights: { [key: string]: string } = {}; // Store dynamic heights


  init(ionEngine: IoniScriptManager): string {
    return '';
  }
  isBracketed(item: string): boolean {
    return item?.trim().startsWith('[');
  }

  ngOnInit() {
    this.contentItems = this.data.contentItems;
    this.listItems = this.data.listItems;
    this.selectedItems = this.listItems[0];

    if (this.data.onSubmit) {
      this.submitIonFunction = LionEngine.ionfunctions[this.data['onSubmit']];
    }
    if (this.submitIonFunction) {
      this.showButton = true;
    }
    if (this.data.button_label) {
      this.submitButtonLabel = this.data.button_label;
    }
    if (this.data.show_button != null) {
      this.displayButton = this.data.show_button;
    }
    if (this.data.title) {
      this.title = this.data.title;
      this.padding_top = '2px';
    }
    if (this.data.single_selection) {
      this.singleSelect = true;
    }
    if (this.data.button_function) {
      this.showButton = false;
      this.displayButton = false;
      this.actionIonFunction = LionEngine.ionfunctions[this.data['button_function']];
    }
    if (this.data.color_set != null) {
      this.color_set = this.data.color_set;
    }
  }

  ngAfterViewInit() {
    // Calculate the dynamic height for each list item
    setTimeout(() => {
      this.listItemElements.forEach((elementRef, index) => {
        const element = elementRef.nativeElement;
        this.itemHeights[this.listItems[index]] = `${element.scrollHeight}px`;
      });
    });
  }

  getDesc(name) {
    if (this.contentItems) {
      return this.contentItems[name];
    }
    return null;
  }

  getBackgroundColor(item) {
    return this.color_set[item] != null ? this.color_set[item] : 'rgba(184, 255, 170, 0.8)';
  }
  // Add this method to selection-list.component.ts
  getOptionBackground(item: string): string {
    // Special color for items that start with '['
    if (this.isBracketed(item)) {
      return 'rgba(25, 118, 210, 0.08)'; // subtle Material-ish blue tint
    } else if ( item === 'Close' || item === 'Back' || item === 'Back...'){
      return 'lightGray'
    }
    // Otherwise fall back to your per-item color_set or default
    return this.getBackgroundColor(item);
  }

  // keep this to match the template's trackBy
  trackByItem(index: number, item: any) {
    return item;
  }
  private _lastActionAt = 0;
  private _lastActionItem: any = null;
  private _touch: { x: number, y: number, t: number } | null = null;

  // ---- Tapping ---------------------------------------------------------------------------
  // Three things can select an option, and on mobile only the last of them is reliable:
  //   (selectionChange)  Material's own event
  //   (click)            the synthesized click a tap is supposed to produce
  //   (touchend)         the touch itself
  //
  // Adding the direct (click) was not enough. Inside a scrollable list a tap that moves even a
  // pixel can be consumed as a scroll gesture, and the synthesized click is then never
  // delivered — so the row highlighted and nothing happened. touchend always arrives, so the
  // tap is decided here from the touch itself: stationary and short means a tap, anything else
  // is a scroll and is left alone.
  private static TAP_SLOP_PX = 14;    // a finger is not a mouse; a few px of travel is still a tap
  private static TAP_MAX_MS = 700;    // longer than this is a press-and-hold, not a tap

  onTouchStart(ev: TouchEvent) {
    try {
      const t = ev.changedTouches && ev.changedTouches[0];
      this._touch = t ? { x: t.clientX, y: t.clientY, t: Date.now() } : null;
    } catch (e) { this._touch = null; }
  }

  onTouchEnd(ev: TouchEvent, item: any) {
    const start = this._touch;
    this._touch = null;
    if (!start) { return; }
    let moved = Infinity, held = Infinity;
    try {
      const t = ev.changedTouches && ev.changedTouches[0];
      if (t) { moved = Math.hypot(t.clientX - start.x, t.clientY - start.y); }
      held = Date.now() - start.t;
    } catch (e) { return; }
    if (moved > SelectionListComponent.TAP_SLOP_PX || held > SelectionListComponent.TAP_MAX_MS) {
      return;   // a scroll or a long press: not ours
    }
    // Consume it, so the browser does not also deliver a synthesized click for the same
    // finger. The de-dupe below would absorb that anyway; this keeps it from firing at all.
    try { ev.preventDefault(); } catch (e) { }
    this.onOptionClick(item);
  }

  onOptionClick(item: any) {
    if (this.singleSelect) this.onChange([item]);
  }
  onChange(event) {
    this.selectedItems = event;
    if (this.actionIonFunction && this.selectedItems.length > 0) {
      if (this.displayButton) this.showButton = true;
    }
    if (this.singleSelect && this.actionIonFunction) {
      // De-duplicated PER ITEM, not by time alone. One gesture reaches onChange from up to
      // three directions (touchend, click, selectionChange) and must act once -- but a bare
      // 350ms window also swallowed a deliberate second tap on a DIFFERENT row, which on a
      // list of short options is an easy thing to do and looked exactly like a dropped tap.
      const now = Date.now();
      const item = (this.selectedItems && this.selectedItems.length) ? this.selectedItems[0] : null;
      if (item === this._lastActionItem && now - this._lastActionAt < 350) { return; }
      this._lastActionAt = now;
      this._lastActionItem = item;
      this.actionIonFunction(this.selectedItems);
    }
  }
  // new handler for selection change
  onSelectionChange(change: MatSelectionListChange) {
    const selectedValues = change.source.selectedOptions.selected.map(o => o.value);
    this.onChange(selectedValues);
  }
  submit() {
    if (this.submitIonFunction) {
      this.submitIonFunction();
    }
    if (this.actionIonFunction) {
      this.actionIonFunction(this.selectedItems);
    }
  }
}
